import { useRouter } from "next/router";
import { FC, useEffect } from "react";

import { storeGclid } from "./helpers";

export const GoogleAdsService: FC<{}> = () => {
    const { asPath } = useRouter();

    useEffect(() => {
        const { gclid } = Object.fromEntries(
            new URLSearchParams(asPath.split("?")[1])
        );
        if (gclid) {
            storeGclid(gclid);
        }
    }, [asPath]);

    return null;
};
